/**
 * List the Repancy desktop windows the user has open right now.
 *
 * Snapshot of WindowContext.windows filtered to non-closed entries.
 * The [window-context] block in the system prompt names the focused
 * window; this tool gives NIPE the full open set + their states.
 */

import type { NipeTool } from './types';

export interface ListOpenWindowsContext {
  listOpenWindows?: () => ReadonlyArray<{
    path: string;
    title: string;
    state: 'open' | 'closed' | 'minimized';
    zIndex: number;
  }>;
}

export const listOpenWindowsTool: NipeTool<ListOpenWindowsContext> = {
  schema: {
    type: 'function',
    function: {
      name: 'listOpenWindows',
      description:
        'List Repancy desktop windows the user currently has open or ' +
        'minimized. Returns path, title, state, and zIndex for each. Use ' +
        'this before closing / focusing a window when you are unsure ' +
        'what is open.',
      parameters: {
        type: 'object',
        properties: {},
        required: [],
      },
    },
  },
  mutatesRemote: false,
  requiresApproval: false,
  handler: async (_args, ctx) => {
    if (!ctx.listOpenWindows) {
      return { error: 'listOpenWindows integration is not available in this session.' };
    }
    const snapshot = ctx.listOpenWindows();
    const visible = snapshot.filter((w) => w.state !== 'closed');
    return { windows: visible };
  },
};
